var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingBag41X44(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69549 17.6769C3.77975 16.6749 4.25636 15.7398 5.03041 15.0581C5.80445 14.3763 6.81913 13.9978 7.87238 13.998H33.1306C34.1838 13.9978 35.1985 14.3763 35.9725 15.0581C36.7466 15.7398 37.2232 16.6749 37.3075 17.6769L38.9895 37.6709C39.0358 38.2212 38.9622 38.7746 38.7734 39.2963C38.5846 39.818 38.2847 40.2968 37.8925 40.7025C37.5004 41.1082 37.0244 41.432 36.4948 41.6535C35.9651 41.875 35.393 41.9895 34.8147 41.9896H6.18822C5.60991 41.9895 5.0379 41.875 4.5082 41.6535C3.9785 41.432 3.50259 41.1082 3.11043 40.7025C2.71826 40.2968 2.41834 39.818 2.22954 39.2963C2.04075 38.7746 1.96716 38.2212 2.01343 37.6709L3.69549 17.6769Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8828 19.9946V9.9976C28.8828 7.8765 28 5.84228 26.4287 4.34244C24.8573 2.8426 22.7261 2 20.5039 2C18.2817 2 16.1505 2.8426 14.5791 4.34244C13.0078 5.84228 12.125 7.8765 12.125 9.9976V19.9946",
    stroke: "current",
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag41X44);
export default __webpack_public_path__ + "static/media/shopping_bag-41x44.03f96f1d9997246f137bad89947ec0aa.svg";
export { ForwardRef as ReactComponent };